// 公用api

import axios from '../utils//fetch';
import utils from '../tool';
import config from '../config';

/**
 * 发送验证码
 */
export function sendCode(options) {
  const url = '/api/zmbiz-teacher-h5-api/api/geetest/validateAndSendCode';
  if (utils.isEmpty(options)) {
    return Promise.reject('options missed');
  }

  if (utils.isEmpty(options.mobile)) {
    return Promise.reject('mobile missed');
  }

  return axios.postSign(url, options);
}

/**
 * 获取极验流水
 */
export function geetestTeah5(options) {
  const url = '/api/zmbiz-teacher-h5-api/api/geetest/register';
  return axios.post(url, options);
}

/**
 * 解密
 */
export function decrypt(options) {
  if (utils.isEmpty(options)) {
    return Promise.reject('options missed');
  }

  if (utils.isEmpty(options.cipher)) {
    return Promise.reject('cipher missed');
  }

  return axios.postSign('/api/zmbiz-teacher-h5-api/common/decrypt', options);
}

/**
 * 加密
 */
export function encrypt(options) {
  if (utils.isEmpty(options)) {
    return Promise.reject('options missed');
  }

  if (utils.isEmpty(options.id)) {
    return Promise.reject('id missed');
  }

  return axios.postSign('/api/zmbiz-teacher-h5-api/common/encrypt', options);
}

/**
 * 获取当前页面的域名部分
 */
export function getBaseUrl() {
  const l = window.location;
  return `${l.protocol}//${l.host}`;
}

/**
 * 获取签合同的链接地址
 */
export function getEntryUrl() {
  return config.entryUrl;
}

/**
 * 获取报名页的链接地址
 */
export function getSignUrl(timeType) {
  if (service.TimeType.isFullTimeType(timeType)) {
    return config.signUrl.fullTimeUrl;
  }

  if (service.TimeType.isPartTimeType(timeType)) {
    return config.signUrl.partTimeUrl;
  }

  return '';
}

/**
 * 获取字典数据
 * @param { JSON } options 选项
 */
export function getCascade(options) {
  const url = '/api/zmbiz-clue-admin/api/common/cascade';
  return axios.post(url, options);
}

/**
 * 获取个人优势
 * @param { JSON } options 选项
 */
export function getAdvantage() {
  return getCascade({
    dicQueryList: [{
      dictCode: 'SPECIAL_ADVANTAGE_T',
    }]});
}

/**
 * 获取教师资格证
 * @param { JSON } options 选项
 */
export function getTeacherCertificate() {
  return getCascade({
    dicQueryList: [
      {
        dictCode: 'TEACHER_PERIOD',
        optionValue: '0',
      },
      {
        dictCode: 'TEACHER_CERTIFICATE',
      },
    ],
  });
}

/**
 * 获取教师资格证阶段
 * @param { JSON } options 选项
 */
export function getCertificatePeriod() {
  return getCascade({
    dicQueryList: [
      {
        dictCode: 'CERTIFICATE_PERIOD',
      },
    ],
  });
}

/**
 * 获取教师资格证学科
 * @param { JSON } options 选项
 */

export function getCertificateSubject() {
  return getCascade({
    dicQueryList: [
      {
        dictCode: 'CERTIFICATE_SUBJECT',
      },
    ],
  });
}
